import { action, observable } from 'mobx';

import { Log } from '@utils';

import {
	Api,
	IFetchNotAppFriendsParams,
	IInviteNotAppFriendsParams,
	IMakeStreamPostParams,
} from '@api';

import { formatFriendsResponse, formatAppResponse } from './utils';

import { IActiveApp, IAppFriend } from '@interfaces';

import { IAppStoreJSON } from './types';

export class AppStore {

	@observable
	notAppFriends: IAppFriend[] = [];

	@observable
	activeApp: IActiveApp = null;

	@action
	fetchNotAppFriends = async (
		params: IFetchNotAppFriendsParams,
		privateKey: string,
	): Promise<IAppFriend[]> => {
		try {
			const response = await Api.app.fetchNotAppFriends(params, privateKey);

			this.notAppFriends = formatFriendsResponse(response.users);

			return this.notAppFriends;
		} catch (err) {
			Log.error(`Failed in getting not app friends in AppStore; Error:`, err);
		}
	};

	@action
	inviteNotAppFriends = async (
		params: IInviteNotAppFriendsParams,
		privateKey: string,
	) => {
		try {
			return Api.app.inviteNotAppFriends(params, privateKey);
		} catch (err) {
			Log.error(`Failed in inviting not app friends in AppStore; Error:`, err);
		}
	};

	@action
	makeStreamPost = async (
		params: IMakeStreamPostParams,
		privateKey: string,
	) => {
		try {
			await Api.app.makeStreamPost(params, privateKey);
		} catch (err) {
			Log.error(`Failed in making stream post in AppStore; Error:`, err);
		}
	};

	@action
	async fetchActiveApp(appId: string) {
		this.activeApp = null;
		try {
			const app = await Api.apps.fetchApp(appId);
			this.activeApp = formatAppResponse(app);
		} catch (err) {
			Log.error(`Couldn't fetch app data: ${err}`);
		}
	}

	@action
	resetActiveApp() {
		this.activeApp = null;
	}

	toJSON(): IAppStoreJSON {
		return {
			activeApp: null,
			notAppFriends: this.notAppFriends,
		};
	}

	fromJSON(data: IAppStoreJSON) {
		this.notAppFriends = [...this.notAppFriends, ...data.notAppFriends];
	}

}
